<div class="a-confirm" [ngClass]="dialogClass">
  <span style="position: absolute;right:10px;top:10px;font-size: 20px;" *ngIf="closable" (click)="onClose()">
    <a class="fa fa-times ui-button ui-button-icon-only"></a>
  </span>
  <div class="a-confirm-title">{{title}}</div>
  <div class="a-confirm-body">
    <i [class]="warningIcon"></i>
    <span class="a-message-l1text" *ngIf="message&&message.length">{{message}}</span>
    <div class="a-message-l2text" *ngFor="let item of details">{{item}}</div>
  </div>
  <div class="a-confirm-footer">
    <button class="secondary-button a-btn-secondary" icon="{{cancelIcon}}" type="button" pButton label="{{cancelText}}"
      (click)="onCancel()" *ngIf="!isCancelHidden"></button>
    <button class="main-button a-btn-primary" icon="{{confirmIcon}}" type="button" pButton label="{{confirmText}}"
      (click)="onConfirm()"></button>
  </div>
</div>